import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";
import { gameTeams } from "@/utils/race-utils";

const Game = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("race")
  ],
  data () {
    return {
      scores: {},
      active: true,
      homeMemberIds: null,
      awayMemberIds: null
    };
  },
  computed: {
    number () {
      return this.race.games.indexOf(this) + 1;
    },
    teams () {
      return gameTeams(this.race, this, this.number);
    },
    homeTeam () {
      return this.teams[0];
    },
    awayTeam () {
      return this.teams[1];
    },
    loaded () {
      if (this.teams.length !== 2) return false;
      return this.teams.flat().every(member => !!member.name);
    }
  }
};

export default defineReactiveModel(Game);